var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGalochka(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.29109 7.63631C3.89075 8.16095 3.10096 8.16077 2.70086 7.63595L1.44565 5.98949C1.16462 5.62086 0.61015 5.61991 0.327864 5.98758C0.134356 6.23962 0.133759 6.59007 0.326406 6.84276L2.70048 9.95686C3.1007 10.4818 3.89078 10.4818 4.29099 9.95686L10.6758 1.58186C10.8673 1.33069 10.8673 0.982514 10.6758 0.731342C10.3952 0.363222 9.84118 0.363096 9.56037 0.731088L4.29109 7.63631Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGalochka);
export default __webpack_public_path__ + "static/media/Galochka.0824932e73ca373cddb33dbce33789fa.svg";
export { ForwardRef as ReactComponent };